import { ModalProvider } from 'react-modal-hook';

import { DocsStoreProvider } from '@modules/docs/providers/DocsStoreProvider';
import { WorkspaceInfoStoreProvider } from '@modules/workspace/providers/WorkspaceInfo';
import SnackbarProvider from 'src/components/snackbar';
import { CollaborationContextProvider } from 'src/features/collaboration';
import { VoiceChannelContextProvider } from 'src/provider/VoiceChannel';
import { VoiceChannelEventsHandler } from 'src/provider/VoiceChannel/VoiceChannelEventsHandler';
import { CollaborateBridgeInitializer } from 'src/services/CollaborateNativeBridge';
import { SocketProvider } from 'src/socket';
import { TodosContextProvider } from '../provider/TodosContext';

/**
 * Contexts that will be available to all authenticated pages.
 *
 * Make sure any provider included here will work as expected when user is not on a workspace, once it will also include wizard and settings pages.
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SocketProvider>
      <CollaborationContextProvider>
        <WorkspaceInfoStoreProvider>
          <VoiceChannelContextProvider>
            <VoiceChannelEventsHandler />
            <TodosContextProvider>
              <CollaborateBridgeInitializer />
              <ModalProvider>
                <SnackbarProvider>{children}</SnackbarProvider>
              </ModalProvider>
            </TodosContextProvider>
          </VoiceChannelContextProvider>
        </WorkspaceInfoStoreProvider>
      </CollaborationContextProvider>
    </SocketProvider>
  );
}

/**
 * Contexts that will be available only when user is on main app
 * It meals on collaborate, communicate or Copera AI chat.
 */
export function MainAppProviders({ children }: { children: React.ReactNode }) {
  return (
    <DocsStoreProvider>
      <ModalProvider>{children}</ModalProvider>
    </DocsStoreProvider>
  );
}
